var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"context-menu-header",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }